import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';

/**
 * IncompleteSectionDialog is a React component that displays a dialog when incomplete sections are detected in the user's profile.
 * It renders a card with a title and a message, and two buttons: a button to cancel the dialog and a button to continue.
 * When the user clicks on the continue button, the component will clear the user's incomplete sections and then call the onClose function.
 * The component also has a state variable, isRemoving, which is used to disable the buttons when the component is in the process of removing the incomplete sections.
 * @param {function} onClose The function to call when the component should close.
 * @param {function} navigateTo The function to call when the user proceeds to the next step.
 * @returns The JSX for the IncompleteSectionDialog component.
 */
const IncompleteSectionDialog = ({ onClose, navigateTo }) => {
    const [isRemoving, setIsRemoving] = useState(false);

    /**
     * Handles the proceed action by removing specified keys from localStorage,
     * setting the isRemoving state to true, and invoking the onClose and navigateTo functions.
     * This effectively clears incomplete sections and navigates the user to the next step.
     */

    const handleProceed = () => {
        setIsRemoving(true);
        ['workExperience', 'education', 'certificate'].forEach(key => localStorage.removeItem(key));
        // onClose();
        navigateTo();
    };

    return (
        <Card className="otp-card-wrapper" variant="outlined">
            <CardContent>

                <Box mb={3} sx={{ textAlign: 'center' }}>
                    <Typography mb={1} className="title" component="h6">
                        Incomplete Sections Found
                    </Typography>
                    <Typography className="otp-sent-txt" component="p">
                        Some profile sections are incomplete. Proceeding will discard saved data.
                    </Typography>
                </Box>

                <Stack direction="row" alignItems={'center'} spacing={3}>
                    <Button
                        fullWidth
                        className="otp-btn"
                        variant="outlined"
                        size="medium"
                        onClick={onClose}
                        disabled={isRemoving}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        className="otp-btn"
                        variant="contained"
                        size="medium"
                        onClick={handleProceed}
                        disabled={isRemoving}>
                        Proceed
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default IncompleteSectionDialog;
